import {
  vacationApiUpsellProvider,
  absenceTypesApiUpsellProvider,
  vacationsApiUpsellProvider,
  attendancesApiUpsellProvider
} from "../../../lib/api/providers";

export const sendVacationApi = async (vacation, token) => {
  const response = await vacationApiUpsellProvider.post("/", vacation, {
    headers: {
      Authorization: token
    }
  });
  return response.data;
};

export const validateVacationApi = async (vacation, token) => {
  const response = await vacationApiUpsellProvider.post("/validate", vacation, {
    headers: {
      Authorization: token
    }
  });
  return response.data;
};

export const rejectVacationApi = async (vacation, token) => {
  const response = await vacationApiUpsellProvider.post("/reject", vacation, {
    headers: {
      Authorization: token
    }
  });
  return response.data;
};

export const modifyVacationApi = async (vacation, token) => {
  const response = await vacationApiUpsellProvider.put("/", vacation, {
    headers: {
      Authorization: token
    }
  });
  return response.data;
};

export const deleteVacationApi = async (vacation, token) => {
  const response = await vacationApiUpsellProvider.post("/delete", vacation, {
    headers: {
      Authorization: token
    }
  });
  return response.data;
};

export const getVacationTypesApi = async token => {
  const response = await absenceTypesApiUpsellProvider.post(
    "/",
    { match: {} },
    {
      headers: {
        Authorization: token
      }
    }
  );
  return response.data;
};

export const fetchVacationsApi = async (filters, token) => {
  const response = await vacationsApiUpsellProvider.post(
    "/",
    {
      match: filters,
      sort: { request_date: -1, start_date: -1 }
    },
    {
      headers: {
        Authorization: token
      }
    }
  );
  return response.data;
};

export const sendAbsenceDeclarationApi = async (absence, token) => {
  const response = await attendancesApiUpsellProvider.post(
    "/declare",
    { ...absence, type: { id: 2 } },
    {
      headers: {
        Authorization: token
      }
    }
  );
  return response.data;
};



// WEBPACK FOOTER //
// src/modules/presence/sagas/vacation.api.js